import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { contactusmail } from "@TKCCP/Services/contactUsService";

type SubmitContactFormParameter = {
    FirstName: string;
    LastName: string;
    Email: string;
    // Country: string;
    PhoneNumber: string;
    Extension: string;
    CompanyName: string;
    StreetAddress1: string;
    StreetAddress2: string;
    City: string;
    State: string;
    Zip: string;
    NumberOfRooms: string;
    ContactUs: boolean;
    TypeofCoffeeMachine: any;
    OtherSubject: string;
    defaultEmailAddress: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactFormParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        FirstName: props.parameter.FirstName,
        LastName: props.parameter.LastName,
        Email: props.parameter.Email,
        // Country: props.parameter.Country,
        PhoneNumber: props.parameter.PhoneNumber,
        Extension: props.parameter.Extension,
        CompanyName: props.parameter.CompanyName,
        StreetAddress1: props.parameter.StreetAddress1,
        StreetAddress2: props.parameter.StreetAddress2,
        City: props.parameter.City,
        State: props.parameter.State,
        Zip: props.parameter.Zip,
        ContactUs: props.parameter.ContactUs,
        NumberOfRooms: props.parameter.NumberOfRooms,
        TypeofCoffeeMachine: props.parameter.TypeofCoffeeMachine,
        defaultEmailAddress: props.parameter.defaultEmailAddress,
        OtherSubject: props.parameter.OtherSubject,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await contactusmail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
